// Logs the CSOC Demo video as viewed for the logged-in user.
// Backed by chess `POST /crm/v1/comms/me/csoc-demo-video-viewed` (session-authed via JWT).
// Fired by the video player when ReactPlayer.onEnded triggers AND the selected
// video is the fixed CSOC Demo video (id 14267). Stamps mt.csoc_demo_video_viewed_at
// in cc_csoc_mentor_task; the comms_v2 lifecycle view derives demo_done from it.
import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface CsocDemoVideoViewedPayload {
  viewedAt?: string; // optional ISO 8601; defaults to server-side timezone.now()
}

export default function useCsocDemoVideoViewedApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<any, Error, CsocDemoVideoViewedPayload | void>(
    async (payload?: CsocDemoVideoViewedPayload | void) => {
      const response = await ChessRestClient.post(
        '/crm/v1/comms/me/csoc-demo-video-viewed',
        payload || {},
      );
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: (error: any) => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return {
    ...mutation,
  };
}
